import React from 'react';
import styled from 'styled-components';

const NavMenuButtonStyled = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 400;
  padding: 0.5rem 1rem;
  cursor: pointer;
  transition: color 0.2s ease;
  text-decoration: none;
  outline: none;

  &:hover {
    color: var(--second-color);
  }

  &:focus {
    outline: none;
  }

  & > i {
    transition: transform 0.2s ease;
    transform: ${props => props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
  }

  @media (max-width: 900px) {
    font-size: 1.05rem;
  }
`;

const NavMenuButton = ({ isOpen, onClick, children }) => {
  return (
    <NavMenuButtonStyled type="button" $isOpen={isOpen} onClick={onClick}>
      {children}
      <i className="fas fa-chevron-down"></i>
    </NavMenuButtonStyled>
  );
};

export default NavMenuButton;

